import Image from "components/Image"
import Link from "components/Link"
import MediaVideo from "components/FeaturedMedia/MediaVideo"
import FeaturedIcon from "components/FeaturedMedia/FeaturedIcon"

function FeaturedMedia({ className = "w-full h-full", article, isHover = false }) {
  const { id, title, shortDescription, externalArticleUrl, thumbnailUrl, fileUrl, fileIsVideo, isActive } =
    article

  const isPostMedia = () => fileIsVideo === true

  const renderContent = () => {
    // VIDEO
    if (fileIsVideo === true && !!fileUrl && isHover) {
      return <MediaVideo isHover videoUrl={fileUrl} />
    }

    // ICON
    return isPostMedia() ? (
      <span className="absolute inset-0 flex items-center justify-center ">
        <FeaturedIcon
          className="hover:scale-105 transform cursor-pointer transition-transform"
          isVideo={fileIsVideo === true}
        />
      </span>
    ) : null
  }

  return (
    <div className={`nc-PostFeaturedMedia relative ${className}`}>
      {/* {postType !== "gallery" && ( */}
      <Image
        alt="featured"
        fill
        className="object-cover"
        src={thumbnailUrl ?? fileUrl}
        sizes="(max-width: 600px) 480px, 800px"
      />
      {/* )} */}
      {renderContent()}
      {/* {postType !== "gallery" && ( */}
      <Link
        href={externalArticleUrl}
        className={`block absolute inset-0 ${
          !fileIsVideo ? "bg-black/20 transition-opacity opacity-0 group-hover:opacity-100" : ""
        }`}
      />
      {/* )} */}
    </div>
  )
}

export default FeaturedMedia
